import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateSessionRetrictedPage = (props) => {
  return (
    <Create
// @ts-ignore
      title='Give user access to a Restricted Page'
      fields={fields}
      apiPath='admin/session_pages'
      successRedirectPath={resource => `/write-now/session_restricted_pages/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateSessionRetrictedPage
